export default __webpack_public_path__ + "static/media/title1.581d7af9.png";